<template>
  <navigation />

    <div class="page-home">

        <promo-header />

        <features />

        <pricing />

        <products />

        <access />

    </div>

  <site-footer />
</template>

<script>
import PromoHeader from "../partials/PromoHeader.vue";
import Features from "../partials/Features.vue";
import Pricing from "../partials/Pricing.vue";
import Products from "../partials/Products.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import Access from "../partials/Access.vue";
import Navigation from "../partials/Navigation.vue";

export default {
  name: "Home",

  components: {
    Navigation,
    Access,
    Products,
    Pricing,
    PromoHeader,
    Features,
    SiteFooter,
  },

    head() {
        return {
            title: `${this.$app.appName} - ${this.$t("home.title")}`,
            meta: [
                {
                    name: 'description',
                    content: "We publish faithful, creative and effective Bible teaching material for children’s and youth ministries.",
                },
            ],
        };
    },
};
</script>
